<template>
  <div class="cf-flex cf-flex--column cf-flex--gap-16 cf-padding-bottom-16">
    <div
      v-if="terms.termsOfService"
      class="cf-content cf-content--header-center cf-content--center"
      v-html="terms.termsOfService"
    />

    <template v-else>
      <span class="cf-icon cf-icon--brand-primary cf-icon--large far fa-exclamation-circle" />

      <h2 class="cf-title cf-title--2">
        Oops! Our terms of service failed to load. Please try again later.
      </h2>
    </template>

    <button
      type="button"
      class="cf-button cf-button--primary cf-button--lg cf-button--fill"
      @click="$closeModal('termsAndConditions')"
    >
      Okay
    </button>
  </div>
</template>


<script>
  import { mapGetters } from 'vuex';


  export default {
    name: 'TermsAndConditions',

    computed: {
      ...mapGetters('content', ['terms'])
    }
  };
</script>
